

// Data o jménech podle plemen
const names = {
  britska: ['Míca', 'Felix', 'Luna', 'Oliver', 'Mia', 'Max', 'Charlie', 'Sofie', 'Simba', 'Bella'],
  ragdoll: ['Tiger', 'Nala', 'Smoky', 'Coco', 'Leo', 'Molly', 'Jasper', 'Sněhulka', 'Garfield', 'Zorro'],
  sibirska: ['Lilly', 'Tom', 'Felix', 'Shadow', 'Misty', 'Cleo', 'Chloe', 'Lucky', 'Pearl', 'Ziggy'],
  mainska_myvali: ['Gizmo', 'Elsa', 'Pumpkin', 'Oscar', 'Rocky', 'Fluffy', 'Ginger', 'Buttons', 'Trixie', 'Snowball'],
  siamska: ['Tigger', 'Milo', 'Phoebe', 'Benny', 'Oreo', 'Sassy', 'Cookie', 'Binky', 'Dusty', 'Kiwi'],
  bengalska: ['Snickers', 'Muffin', 'Whiskey', 'Poppy', 'Lulu', 'Yoda', 'Peach', 'Sophie', 'Pixie', 'Sasha'],
  perska: ['Patch', 'Angel', 'Toto', 'Lola', 'Chloe', 'Venus', 'Casper', 'Tilly', 'Blue', 'Daisy'],
  sphynx: ['Murphy', 'Ziggy', 'Marley', 'Felix', 'Mochi', 'Frankie', 'Spice', 'Oscar', 'Peanut', 'Minnie'],
  chartreux: ['Pepper', 'Rosie', 'Binx', 'Velvet', 'Pusheen', 'Willow', 'Tango', 'Zelda', 'Harley', 'Frosty'],
  norska_lesni: ['Bambi', 'Nelly', 'Percy', 'Olive', 'Míca', 'Felix', 'Luna', 'Oliver', 'Mia', 'Max'],
  skotska_klapoucha: ['Charlie', 'Sofie', 'Simba', 'Bella', 'Tiger', 'Nala', 'Smoky', 'Coco', 'Leo', 'Molly'],
  exoticka_kratkosrsta: ['Jasper', 'Sněhulka', 'Garfield', 'Zorro', 'Lilly', 'Tom', 'Felix', 'Shadow', 'Misty', 'Cleo'],
  devon_rex: ['Chloe', 'Lucky', 'Pearl', 'Ziggy', 'Gizmo', 'Elsa', 'Pumpkin', 'Oscar', 'Rocky', 'Fluffy'],
  korat: ['Ginger', 'Buttons', 'Trixie', 'Snowball', 'Tigger', 'Milo', 'Phoebe', 'Benny', 'Oreo', 'Sassy'],
  birma: ['Cookie', 'Binky', 'Dusty', 'Kiwi', 'Snickers', 'Muffin', 'Whiskey', 'Poppy', 'Lulu', 'Yoda'],
  orientalni_kratkosrsta: ['Peach', 'Sophie', 'Pixie', 'Sasha', 'Patch', 'Angel', 'Toto', 'Lola', 'Chloe', 'Venus'],
  balineska: ['Casper', 'Tilly', 'Blue', 'Daisy', 'Murphy', 'Ziggy', 'Marley', 'Felix', 'Mochi', 'Frankie'],
  tonkinska: ['Spice', 'Oscar', 'Peanut', 'Minnie', 'Pepper', 'Rosie', 'Binx', 'Velvet', 'Pusheen', 'Willow'],
  singapurska: ['Tango', 'Zelda', 'Harley', 'Frosty', 'Bambi', 'Nelly', 'Percy', 'Olive', 'Míca', 'Felix'],
  havanska: ['Luna', 'Oliver', 'Mia', 'Max', 'Charlie', 'Sofie', 'Simba', 'Bella', 'Tiger', 'Nala'],
  turecka_angora: ['Smoky', 'Coco', 'Leo', 'Molly', 'Jasper', 'Sněhulka', 'Garfield', 'Zorro', 'Lilly', 'Tom'],
  egyptska_mau: ['Felix', 'Shadow', 'Misty', 'Cleo', 'Chloe', 'Lucky', 'Pearl', 'Ziggy', 'Gizmo', 'Elsa'],
  barmska: ['Pumpkin', 'Oscar', 'Rocky', 'Fluffy', 'Ginger', 'Buttons', 'Trixie', 'Snowball', 'Tigger', 'Milo'],
  americka_kratkosrsta: ['Phoebe', 'Benny', 'Oreo', 'Sassy', 'Cookie', 'Binky', 'Dusty', 'Kiwi', 'Snickers', 'Muffin'],
  ocicat: ['Whiskey', 'Poppy', 'Lulu', 'Yoda', 'Peach', 'Sophie', 'Pixie', 'Sasha', 'Patch', 'Angel'],
  serengeti: ['Toto', 'Lola', 'Chloe', 'Venus', 'Casper', 'Tilly', 'Blue', 'Daisy', 'Murphy', 'Ziggy'],
  selkirk_rex: ['Marley', 'Felix', 'Mochi', 'Frankie', 'Spice', 'Oscar', 'Peanut', 'Minnie', 'Pepper', 'Rosie'],
  pixiebob: ['Binx', 'Velvet', 'Pusheen', 'Willow', 'Tango', 'Zelda', 'Harley', 'Frosty', 'Bambi', 'Nelly'],
  laperm: ['Percy', 'Olive', 'Míca', 'Felix', 'Luna', 'Oliver', 'Mia', 'Max', 'Charlie', 'Sofie'],
  japonsky_bobtail: ['Simba', 'Bella', 'Tiger', 'Nala', 'Smoky', 'Coco', 'Leo', 'Molly', 'Jasper', 'Sněhulka']
};

// Data o jménech podle povah
const personalities = {
  aktivni: ['Tigger', 'Ziggy', 'Simba', 'Felix', 'Mia'],
  citliva: ['Míca', 'Lilly', 'Sofie', 'Charlie', 'Bella'],
  dominantni: ['Sněhulka', 'Fluffy', 'Garfield', 'Misty', 'Cleo'],
  energicka: ['Tiger', 'Nala', 'Smoky', 'Coco', 'Leo'],
  elegantni: ['Max', 'Charlie', 'Sofie', 'Simba', 'Bella'],
  hlucna: ['Trixie', 'Oscar', 'Ginger', 'Muffin', 'Binky'],
  hrava: ['Felix', 'Simba', 'Ziggy', 'Pumpkin', 'Toto'],
  hrubá: ['Zorro', 'Rocky', 'Smoky', 'Shadow', 'Binx'],
  hrůzostrašná: ['Casper', 'Velvet', 'Frosty', 'Pusheen', 'Tango'],
  inteligentni: ['Kiwi', 'Oscar', 'Snickers', 'Whiskey', 'Oreo'],
  jemná: ['Daisy', 'Mia', 'Pixie', 'Poppy', 'Rosie'],
  klidna: ['Misty', 'Fluffy', 'Lilly', 'Blue', 'Willow'],
  krotka: ['Garfield', 'Max', 'Felix', 'Cleo', 'Ziggy'],
  lina: ['Sněhulka', 'Milo', 'Garfield', 'Whiskey', 'Tilly'],
  lstiva: ['Oscar', 'Cleo', 'Toto', 'Peanut', 'Sassy'],
  mazaná: ['Shadow', 'Felix', 'Rocky', 'Ginger', 'Lola'],
  mazliva: ['Míca', 'Luna', 'Bella', 'Simba', 'Lilly'],
  mrstná: ['Trixie', 'Snickers', 'Kiwi', 'Sasha', 'Percy'],
  neustupná: ['Peach', 'Angel', 'Dusty', 'Nala', 'Venus'],
  nezávislá: ['Simba', 'Oscar', 'Misty', 'Felix', 'Shadow'],
  neduverivá: ['Lola', 'Trixie', 'Ziggy', 'Milo', 'Misty'],
  oddaná: ['Binky', 'Toto', 'Willow', 'Harley', 'Murphy'],
  opatrná: ['Yoda', 'Olive', 'Cleo', 'Velvet', 'Poppy'],
  plachá: ['Ziggy', 'Nala', 'Pearl', 'Elsa', 'Phoebe'],
  pozorná: ['Binx', 'Felix', 'Whiskey', 'Peanut', 'Pixie'],
  přátelská: ['Bella', 'Oscar', 'Charlie', 'Lulu', 'Peach'],
  rozmazlená: ['Muffin', 'Cleo', 'Gizmo', 'Sophie', 'Sassy'],
  rozvážná: ['Tilly', 'Venus', 'Oscar', 'Lola', 'Percy'],
  sebevědomá: ['Rocky', 'Ziggy', 'Tango', 'Zorro', 'Simba'],
  sledovací: ['Phoebe', 'Velvet', 'Peanut', 'Whiskey', 'Percy'],
  stydlivá: ['Misty', 'Dusty', 'Milo', 'Sasha', 'Coco'],
  temperantní: ['Tango', 'Binx', 'Zelda', 'Murphy', 'Simba'],
  teritorialni: ['Tiger', 'Zorro', 'Nala', 'Smoky', 'Leo'],
  úzkostlivá: ['Tilly', 'Murphy', 'Zelda', 'Blue', 'Bambi'],
  učenlivá: ['Elsa', 'Peach', 'Pixie', 'Minnie', 'Bambi'],
  vyrovnaná: ['Nala', 'Sofie', 'Max', 'Toto', 'Milo'],
  zamilovaná_do_lidí: ['Bella', 'Simba', 'Felix', 'Oscar', 'Mia'],
  zlobivá: ['Pumpkin', 'Zorro', 'Shadow', 'Ziggy', 'Trixie'],
  zákeřná: ['Sassy', 'Snickers', 'Tilly', 'Patch', 'Harley']
};

// Při kliknutí na tlačítko generovat jména
document.getElementById('generate-names').addEventListener('click', function() {
  // Získání vybraného plemena
  const breed = document.getElementById('breed').value;

  // Získání vybraných povah (checkboxy)
  const selectedPersonalities = Array.from(document.querySelectorAll('input[name="personality"]:checked'))
    .map(cb => cb.value);

  // Získání jmen podle vybraného plemene a povah
  let selectedNames = names[breed] || [];

  selectedPersonalities.forEach(personality => {
    if (personalities[personality]) {
      selectedNames = [...selectedNames, ...personalities[personality]];
    }
  });

  // Náhodný výběr 5 jmen
  const randomNames = [];
  while (randomNames.length < 5 && selectedNames.length > 0) {
    const randomIndex = Math.floor(Math.random() * selectedNames.length);
    randomNames.push(selectedNames.splice(randomIndex, 1)[0]); // Vybere a odstraní náhodné jméno
  }

  // Zobrazení výsledků
  document.getElementById('name-results').innerHTML = `
    <h3>Generovaná jména:</h3>
    <ul>
      ${randomNames.map(name => `<li>${name}</li>`).join('')}
    </ul>
  `;
});


